import { useTranslation } from "react-i18next";

export const ComingSoon = () => {
  const {t,i18n}=useTranslation();
  return (
    <>
          <div className="flex h-full  w-full justify-center items-center h4">
             {t('ComingSoon')}
          </div>
    </>
  );
};
